import { getRunTime } from '../../../public-resource/libs/utils/index'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let API_HOST = '//marketing.xinli001.cc'

module.exports = {
  // getDeclaration: `http://m-box5.xinli001.com/qa/invitation/get-manifesto.json`,
  getDeclaration: `${HOST}/qa/invitation/get-manifesto.json`, // 宣言
  getRecordList: `${API_HOST}/api/wevent/qa/coin/info`, // 邀请记录
  withdraw: `${API_HOST}/api/wevent/qa/coin/tixian`, // 提现
  getWXShareConfig: `${HOST}/wx/get-wx-package.json` // 微信分享
}



// WEBPACK FOOTER //
// ./src/pages/ask/inviteAnswer/api.js